import React from "react";
import {Card, CardActionArea, CardContent, CardMedia, Grid, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import lineChartPreview from "../assets/reports/income-vs-expense.svg";
import barChartPreview from "../assets/reports/bar-chart.svg";
import {useTranslation} from "react-i18next";

const ReportsIncomeVsExpensePage = () => {
    const {t} = useTranslation();
    return (
        <PageLayout title={t("pages.reports.incomeVsExpense.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: "90%", overflowY: "auto"}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/income-vs-expense/lineChart">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={lineChartPreview}
                                    alt={t("pages.reports.incomeVsExpense.cards.line.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.incomeVsExpense.cards.line.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.incomeVsExpense.cards.line.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/income-vs-expense/barChart">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={barChartPreview}
                                    alt={t("pages.reports.incomeVsExpense.cards.bar.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.incomeVsExpense.cards.bar.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.incomeVsExpense.cards.bar.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            </CardContent>
        </PageLayout>
    );
};

export default ReportsIncomeVsExpensePage;
